import { useChangesContext } from "../contexts/ChangesContext";

/**
 * The count of assignment changes still to handle, as the nav badge shows it.
 *
 * A reader over `ChangesContext`, which does the counting: the dashboard card shows the
 * same figure, and a hook that fetched per caller would have polled twice and let the
 * two displays drift apart between polls.
 */
export const useUnreadChangesCount = () => {
  const { pendingCount, pendingLoading } = useChangesContext();

  return { unreadCount: pendingCount, loading: pendingLoading };
};
